import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {ThreePanesLayout} from '@github-ui/three-panes-layout'
import {graphql, useFragment} from 'react-relay'

import type {RepositoryMilestonesInternal$key} from './__generated__/RepositoryMilestonesInternal.graphql'
import {LABELS} from './constants/labels'
import {MilestoneError} from './MilestoneError'
import {MilestoneList} from './MilestoneList'
import {MilestonesActions} from './MilestonesActions'
import styles from './RepositoryMilestone.module.css'

type RepositoryMilestonesInternalProps = {
  repository: RepositoryMilestonesInternal$key
}

export function RepositoryMilestonesInternal({repository}: RepositoryMilestonesInternalProps) {
  const data = useFragment(
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    graphql`
      fragment RepositoryMilestonesInternal on Repository
      @argumentDefinitions(
        state: {type: "MilestoneState!"}
        orderField: {type: "MilestoneOrderField", defaultValue: CREATED_AT}
        orderDirection: {type: "OrderDirection", defaultValue: DESC}
      ) {
        ...MilestoneList @arguments(state: $state, first: 50, orderField: $orderField, orderDirection: $orderDirection)
        ...MilestonesActions
      }
    `,
    repository,
  )

  return (
    <ThreePanesLayout
      contentAs="div"
      resizeable={false}
      leftPaneWidth="small"
      middlePane={
        <div className={styles.middlePaneWrapper}>
          <ErrorBoundary
            fallback={<MilestoneError title={LABELS.milestonesError} message={LABELS.milestonesErrorMessage} />}
          >
            <MilestonesActions repositoryRef={data} />
            <MilestoneList repositoryRef={data} />
          </ErrorBoundary>
        </div>
      }
    />
  )
}
